import { useState } from "react";

import {
  Button,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import { CustomNumberField } from "../custom-number-field";
import {
  ProductVariantPicker,
  useProductVariantPicker,
} from "../product-variant-picker";

export const AddProductVariantSection = ({
  onAdded,
  outletId,
  productSelectLabel = "Produk",
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const picker = useProductVariantPicker();
  const { productVariant, product, loading, reset } = picker;

  const [quantity, setQuantity] = useState(1);

  const handleAdd = () => {
    onAdded(productVariant, product, quantity);
    reset();
    setQuantity(1);
  };

  return (
    <Stack spacing={2} direction={isSmallScreen ? "column" : "row"}>
      <Grid container spacing={2} sx={{
        flex: 2
      }}>
        <Grid size={{ xs: 12 }}>
          <ProductVariantPicker
            picker={picker}
            outletId={outletId}
            productSelectLabel={productSelectLabel}
          />
        </Grid>
      </Grid>
      <Divider
        sx={{ py: 0 }}
        orientation={isSmallScreen ? "horizontal" : "vertical"}
        flexItem
      />
      <Grid container spacing={3} sx={{
        flex: 1
      }}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2">SKU Produk Varian</Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              mt: 1
            }}>
            {loading.variant ? "Loading ..." : (productVariant?.sku ?? "-")}
            {productVariant && productVariant?.status === false && (
              <Typography
                component="span"
                variant="body1"
                color="error"
                sx={{ ml: 1 }}
              >
                (Tidak aktif)
              </Typography>
            )}
          </Typography>
        </Grid>
        <Grid size={6}>
          <CustomNumberField
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            disabled={!productVariant}
            label="Jumlah"
            required={true}
            InputProps={{
              placeholder: "Cth: 5",
            }}
            inputProps={{ min: 1 }}
          />
        </Grid>
        <Grid size={6}>
          <Typography
            variant="body2"
            color={productVariant ? "inherit" : "text.disabled"}
          >
            Keranjang
          </Typography>
          <Button
            fullWidth
            variant="contained"
            disabled={!productVariant || productVariant?.status === false}
            sx={{ mt: 1 }}
            onClick={handleAdd}
          >
            Tambah
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};

AddProductVariantSection.propTypes = {
  onAdded: PropTypes.func.isRequired,
  outletId: PropTypes.string,
  productSelectLabel: PropTypes.string,
};
